import * as React from 'react';

import URI from 'jsuri';
import PropTypes from 'prop-types';
import Q from 'q';
import type { LegacyContextType } from 'types/legacy-context-types';
import _ from 'underscore';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import mapProps from 'js/lib/mapProps';
import path from 'js/lib/path';
import waitFor from 'js/lib/waitFor';

import api from 'bundles/discussions/api/questions';
import { moveQuestion } from 'bundles/discussions/api/threadActionsApiUtil';
import { ForumSelector } from 'bundles/discussions/components/NewThreadForm';
import discussionsForumsHOC from 'bundles/discussions/components/discussionsForumsHOC';
import { naptimeForumTypes } from 'bundles/discussions/constants';
import { buildUrl } from 'bundles/discussions/utils/discussionsUrl';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandCourseForumsV1 from 'bundles/naptimejs/resources/onDemandCourseForums.v1';
import Modal from 'bundles/phoenix/components/Modal';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/MoveThreadModal';

class MoveThreadModal extends React.Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    handleClose: PropTypes.func.isRequired,
    userId: PropTypes.number.isRequired,
    courseId: PropTypes.string,
    rootPath: PropTypes.string,
    courseForums: PropTypes.arrayOf(PropTypes.instanceOf(OnDemandCourseForumsV1)),
    questionForum: PropTypes.instanceOf(OnDemandCourseForumsV1),
    rootForumId: PropTypes.string,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof MoveThreadModal.contextTypes>;

  constructor(props: $TSFixMe, context: $TSFixMe) {
    super(props, context);

    // filter out all subforums and the root forum
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'rootForumId' does not exist on type 'Rea... Remove this comment to see the full error message
    const forumsWithoutSubforums = props.courseForums.filter((forum) => forum.parentForumId === this.props.rootForumId);
    // add back the subforums so that they are in the correct order
    const forums = _(
      forumsWithoutSubforums.map((parentForum: $TSFixMe) =>
        [parentForum].concat(props.courseForums.filter((forum: $TSFixMe) => forum.parentForumId === parentForum.id))
      )
    )
      .flatten()
      .map((forum) => Object.assign(forum, { type: forum.forumType.typeName }));
    const selectedForum = Object.assign(props.questionForum, {
      type: props.questionForum.forumType.typeName,
    });
    const initialId = props.questionForum.id;

    this.state = {
      saving: false,
      saveError: false,
      selectedForum,
      forums,
      initialId,
    };
  }

  handleSaveSuccess = () => {
    this.closeModal();
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 4 arguments, but got 2.
    const url = buildUrl(path.join(this.props.rootPath, this.state.selectedForum.link), this.props.question.questionId);
    this.context.router.push(url);
  };

  handleSaveError = (error: $TSFixMe) => {
    this.setState({
      saveError: true,
      saving: false,
    });
  };

  handleInputChange = (placeholder: $TSFixMe, event: $TSFixMe) => {
    this.setState({
      selectedForum: event.value,
    });
  };

  handleCloseModal = () => {
    this.closeModal();
  };

  handleCancel = () => {
    this.closeModal();
  };

  handleSubmit = () => {
    const moveApiCall = moveQuestion(
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'question' does not exist on type 'Readon... Remove this comment to see the full error message
      this.props.question.id,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseId' does not exist on type 'Readon... Remove this comment to see the full error message
      this.props.courseId,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedForum' does not exist on type 'R... Remove this comment to see the full error message
      this.state.selectedForum.forumId,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedForum' does not exist on type 'R... Remove this comment to see the full error message
      this.state.selectedForum.type,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'userId' does not exist on type 'Readonly... Remove this comment to see the full error message
      this.props.userId
    );
    if (moveApiCall) {
      // @ts-expect-error ts-migrate(2555) FIXME: Expected at least 1 arguments, but got 0.
      moveApiCall.then(this.handleSaveSuccess).fail(this.handleSaveError).done();

      this.setState({ saving: true });
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedForum' does not exist on type 'R... Remove this comment to see the full error message
      const selectedForum = this.state.selectedForum;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'question' does not exist on type 'Readon... Remove this comment to see the full error message
      const uri = new URI().addQueryParam('action', 'move').addQueryParam('id', this.props.question.id);

      const options = {
        context: {
          typeName: selectedForum.type,
          definition: {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseId' does not exist on type 'Readon... Remove this comment to see the full error message
            courseId: this.props.courseId,
          },
        },
      };

      if (selectedForum.type === 'week') {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'weekNumber' does not exist on type '{ co... Remove this comment to see the full error message
        options.context.definition.weekNumber = parseInt(selectedForum.id, 10);
      } else {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        options.context.definition[selectedForum.type + 'Id'] = selectedForum.id;
      }

      Q(api.post(uri.toString(), { data: options }))
        .then(this.handleSaveSuccess)
        .catch(this.handleSaveError)
        .done();

      this.setState({ saving: true });
    }
  };

  closeModal() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleClose' does not exist on type 'Rea... Remove this comment to see the full error message
    this.props.handleClose();
  }

  render() {
    const saveError = (
      <div className="c-error-text c-form-error-message">
        {_t('Sorry, there was a problem moving this thread. Please reload the page and try again.')}
      </div>
    );

    return (
      <div className="rc-MoveThreadModal styleguide">
        <Modal handleClose={this.handleCloseModal} modalName={_t('Move thread')} ref="moveThreadModal">
          <h1 className="c-modal-title display-1-text">{_t('Move Thread')}</h1>
          {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'forums' does not exist on type 'Readonly... Remove this comment to see the full error message */}
          {this.state.forums && (
            <ForumSelector
              handleInputChange={this.handleInputChange}
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'forums' does not exist on type 'Readonly... Remove this comment to see the full error message
              forums={this.state.forums}
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedForum' does not exist on type 'R... Remove this comment to see the full error message
              value={this.state.selectedForum}
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'rootForumId' does not exist on type 'Rea... Remove this comment to see the full error message
              rootForumId={this.props.rootForumId}
            />
          )}
          <div className="horizontal-box align-items-right">
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'saveError' does not exist on type 'Reado... Remove this comment to see the full error message */}
            {this.state.saveError && saveError}
            <button className="passive" onClick={this.handleCancel}>
              {_t('Cancel')}
            </button>
            <button
              ref="submit"
              disabled={
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'saving' does not exist on type 'Readonly... Remove this comment to see the full error message
                this.state.saving || !this.state.selectedForum || this.state.selectedForum.id === this.state.initialId
              }
              className="secondary"
              type="submit"
              onClick={this.handleSubmit}
            >
              {_t('Submit')}
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default _.compose(
  connectToStores(['CourseStore', 'ApplicationStore'], ({ CourseStore, ApplicationStore }) => {
    return {
      userId: ApplicationStore.getUserData().id,
      courseId: CourseStore.getCourseId(),
      rootPath: `/learn/${CourseStore.getCourseSlug()}`,
    };
  }),
  discussionsForumsHOC({ fields: ['title', 'forumType', 'link'] }),
  mapProps((props) => {
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    const questionForumId = props.question.forumId;
    const rootForum =
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      props.courseForums &&
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      props.courseForums.find((forum) => forum.forumType.typeName === naptimeForumTypes.rootForumType);
    return {
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      questionForum: props.courseForums && props.courseForums.find((forum) => forum.forumId === questionForumId),
      rootForumId: rootForum && rootForum.id,
    };
  }),
  waitFor((props) => !!props.courseForums && !!props.questionForum)
)(MoveThreadModal);
